

























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Navbar extends Vue {
	activeLink: string = '';

	toggle (target: string, e: Event) {
	  this.activeLink = this.activeLink === target ? '' : target
	  this.$emit('toggle', target)
	  e.preventDefault()
	}

	public close () {
	  this.activeLink = ''
	}
}
